<template>
  <div class="root-box" v-loading="loading">
    <el-table :data="rows" :default-expand-all="false" :max-height="tableHeight" class="no-hover" ref="table" stripe>
      <el-table-column type="expand">
        <template slot-scope="props">
          <div class="table-expand">
            <div v-if="(props.row.trips || []).length" class="section plan">
              <el-table :data="props.row.trips" size="small" class="no-hover plan-table"
                :header-cell-style="planHeaderStyle" :cell-style="planCellStyle">
                <el-table-column label="司机" prop="driverNo" width="90"></el-table-column>
                <el-table-column label="最早出发" width="140">
                  <template slot-scope="scope">
                    {{ scope.row.stime | dateFormat("yyyy-MM-dd hh:mm") }}
                  </template>
                </el-table-column>
                <el-table-column label="最晚出发" width="140">
                  <template slot-scope="scope">
                    {{ scope.row.etime | dateFormat("yyyy-MM-dd hh:mm") }}
                  </template>
                </el-table-column>
                <el-table-column label="可售" width="70">
                  <template slot-scope="scope">
                    <span class="primary">{{ scope.row.sellableSeats }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="当前积分" width="80">
                  <template slot-scope="scope">
                    {{ scope.row.routePoints == null ? 0 : scope.row.routePoints }}
                  </template>
                </el-table-column>
                <el-table-column label="类型" width="70">
                  <template slot-scope="scope">
                    {{ scope.row.actualTrip ? "真实" : "规划" }}
                  </template>
                </el-table-column>
                <el-table-column min-width="1"></el-table-column>
              </el-table>
            </div>
            <div v-if="(props.row.latentVehicles || []).length" class="section idle">
              <el-table :data="props.row.latentVehicles" size="small" class="no-hover idle-table"
                :header-cell-style="idleHeaderStyle" :cell-style="idleCellStyle">
                <el-table-column label="司机" prop="driverNo" width="90"></el-table-column>
                <el-table-column label="区域" width="120">
                  <template slot-scope="scope">
                    {{ scope.row.areaId | enumTransfer(areaOpts, "id", "name") }}
                  </template>
                </el-table-column>
                <el-table-column label="到达/空闲自" width="140">
                  <template slot-scope="scope">
                    {{ scope.row.lastArriveTime | dateFormat("yyyy-MM-dd hh:mm") }}
                  </template>
                </el-table-column>
                <el-table-column label="座位" width="70">
                  <template slot-scope="scope">
                    <span class="secondary">{{ scope.row.seats }} 座</span>
                  </template>
                </el-table-column>
                <el-table-column label="当前积分" width="80">
                  <template slot-scope="scope">
                    {{ scope.row.routePoints == null ? 0 : scope.row.routePoints }}
                  </template>
                </el-table-column>
                <el-table-column min-width="1"></el-table-column>
              </el-table>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="时段" prop="showTime" width="130"></el-table-column>
      <el-table-column label="U" width="80">
        <template slot-scope="scope">
          {{ scope.row.u | numFormat(2) }}
        </template>
      </el-table-column>
      <el-table-column label="余票" width="120">
        <template slot-scope="scope">
          <span class="ticket-num">{{ scope.row.ticketNum || 0 }} 张</span>
          <span class="disable-share-ticket" v-if="scope.row.disableShareTicket">（禁共票）</span>
        </template>
      </el-table-column>
      <el-table-column label="候补" width="80">
        <template slot-scope="scope">
          <span :class="scope.row.backupNum > 0 ? 'backup-num' : 'backup-num-zero'">
            {{ scope.row.backupNum || 0 }} 张
          </span>
        </template>
      </el-table-column>
      <el-table-column label="合计可售" width="110">
        <template slot-scope="scope">
          <span class="primary">{{ scope.row.plannedSellable + scope.row.latentSellable }} 张</span>
        </template>
      </el-table-column>
      <el-table-column label="已规划" width="110">
        <template slot-scope="scope">
          <span class="primary">{{ scope.row.plannedSellable }} 张</span>
        </template>
      </el-table-column>
      <el-table-column label="空闲" width="120">
        <template slot-scope="scope">
          <span class="secondary">{{ scope.row.latentSellable }} 座</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="90">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="toggleRow(scope.row)">展开详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="page">
      <span class="pagination-sum">
        峰值已规划可售 {{ peakPlanned }} 张（{{ peakShowTime }}）
      </span>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    rows: {
      type: Array,
      default: () => []
    },
    tableHeight: {
      type: Number,
      default: 480
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      areaOpts: (state) => state.areaOpts || []
    }),
    peakPlanned() {
      return (this.rows || []).reduce((max, item) => Math.max(max, item.plannedSellable || 0), 0);
    },
    peakShowTime() {
      const target = (this.rows || []).find((item) => item.plannedSellable === this.peakPlanned);
      if (!target) return "-";
      return target.showTime;
    }
  },
  methods: {
    planHeaderStyle() {
      return {
        background: "#d9ecff",
        color: "#409eff",
        borderBottomColor: "#c6e2ff"
      };
    },
    planCellStyle() {
      return {
        background: "#ecf5ff",
        borderBottomColor: "#c6e2ff"
      };
    },
    idleHeaderStyle() {
      return {
        background: "#faecd8",
        color: "#e6a23c",
        borderBottomColor: "#f5dab1"
      };
    },
    idleCellStyle() {
      return {
        background: "#fdf6ec",
        borderBottomColor: "#f5dab1"
      };
    },
    toggleRow(row) {
      this.$refs.table.toggleRowExpansion(row);
    }
  }
};
</script>

<style lang="less" scoped>
.root-box {
  height: 100%;
  overflow: hidden;
}

.page {
  padding-top: 4px;
  line-height: 20px;
  box-sizing: border-box;
  height: 28px;
}

.table-expand {
  padding: 0 0 12px 48px;
}

.section {
  margin-bottom: 8px;
  padding: 0;
  border-radius: 4px;
  border-left: 3px solid transparent;
  overflow: hidden;

  &:last-child {
    margin-bottom: 0;
  }

  &.plan {
    background: #ecf5ff;
    border-left-color: #409eff;

    .section-title {
      color: #409eff;
    }

    /deep/ .plan-table {
      width: 100%;
      background-color: #ecf5ff !important;

      &::before {
        background-color: #c6e2ff !important;
      }

      .el-table__header,
      .el-table__body {
        width: 100% !important;
      }

      .el-table__header-wrapper,
      .el-table__body-wrapper,
      .el-table__empty-block {
        background-color: #ecf5ff !important;
      }

      th,
      td {
        border-right: none;
      }

      th {
        background-color: #d9ecff !important;
        color: #409eff;
        border-bottom-color: #c6e2ff !important;
      }

      td {
        background-color: #ecf5ff !important;
        color: #303133;
        border-bottom-color: #c6e2ff !important;
      }

      .el-table__body tr:hover>td {
        background-color: #ecf5ff !important;
      }
    }
  }

  &.idle {
    background: #fdf6ec;
    border-left-color: #e6a23c;

    .section-title {
      color: #e6a23c;
    }

    /deep/ .idle-table {
      width: 100%;
      background-color: #fdf6ec !important;

      &::before {
        background-color: #f5dab1 !important;
      }

      .el-table__header,
      .el-table__body {
        width: 100% !important;
      }

      .el-table__header-wrapper,
      .el-table__body-wrapper,
      .el-table__empty-block {
        background-color: #fdf6ec !important;
      }

      th,
      td {
        border-right: none;
      }

      th {
        background-color: #faecd8 !important;
        color: #e6a23c;
        border-bottom-color: #f5dab1 !important;
      }

      td {
        background-color: #fdf6ec !important;
        color: #303133;
        border-bottom-color: #f5dab1 !important;
      }

      .el-table__body tr:hover>td {
        background-color: #fdf6ec !important;
      }
    }
  }
}

.section-title {
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 4px;
}

.primary {
  color: #409eff;
  font-weight: 500;
}

.secondary {
  color: #e6a23c;
}

.ticket-num {
  color: #67c23a;
  font-weight: 500;
}

.backup-num {
  color: #e6a23c;
  font-weight: 500;
}

.backup-num-zero {
  color: #c0c4cc;
}

.disable-share-ticket {
  color: #f56c6c;
  font-size: 12px;
  display: inline-block;
}

.pagination-sum {
  color: #409eff;
  font-size: 12px;
  display: inline-block;
}
</style>
